module.exports = __webpack_public_path__ + "static/media/fixed_voice_info_close.4534b7ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_info_close.svg
// module id = 3160
// module chunks = 0